import React from 'react';

interface AppErrorBoundaryState {
  error: Error | null;
}

export default class AppErrorBoundary extends React.Component<React.PropsWithChildren, AppErrorBoundaryState> {
  override state: AppErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  override componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[app-error-boundary]', error, errorInfo);
  }

  override render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="min-h-screen bg-surface-sunken flex items-center justify-center px-6">
        <section className="w-full max-w-lg rounded-2xl border border-line bg-surface shadow-sm p-6 text-center">
          <p className="text-xs font-semibold uppercase tracking-wide text-danger mb-2">
            Page failed to load
          </p>
          <h1 className="text-2xl font-semibold text-ink">Refresh this page.</h1>
          <p className="mt-3 text-sm text-ink-muted">
            POE hit a client-side rendering error. Refreshing usually restores the latest app bundle.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-5 inline-flex items-center justify-center rounded-lg bg-brand px-4 py-2 text-sm font-semibold text-brand-fg hover:opacity-90 transition-opacity"
          >
            Reload
          </button>
        </section>
      </main>
    );
  }
}
